import React, { useCallback } from 'react';

import OnboardingWizardContentWrapper from '../OnboardingWizardWrappers/OnboardingWizardContentWrapper/OnboardingWizardContentWrapper';
import WorkspacesPreview from '../WorkspacesPreview/WorkspacesPreview';
import FeedbackComponent from './FeedbackComponent/FeedbackComponent';
import FormFields from './FormFields/FormFields';

import { WorkspacesType } from '../../types';

import './ManagerAssistantSettings.scss';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
  managerAssistantSettings: {
    recurrenceAmount: number;
    recurrenceInterval: string;
  };
};

export default function ManagerAssistantSettings({
  workspaces,
  managerAssistantSettings,
  advanceOnboardingState,
}: Props) {
  const handleSubmit = useCallback(
    values => {
      return advanceOnboardingState({
        manager_assistant_settings: {
          recurrenceAmount: Number(values.managerAssistantSettings.recurrenceAmount),
          recurrenceInterval: values.managerAssistantSettings.recurrenceInterval,
        },
      });
    },
    [advanceOnboardingState]
  );

  return (
    <OnboardingWizardContentWrapper
      initialValues={{
        workspaces,
        managerAssistantSettings: {
          recurrenceAmount: managerAssistantSettings?.recurrenceAmount || 2,
          recurrenceInterval: managerAssistantSettings?.recurrenceInterval || 'week',
        },
      }}
      onNextStep={handleSubmit}
      previewSectionContent={<WorkspacesPreview workspaceContent={<FeedbackComponent />} />}
    >
      <div className="onboarding-mas scrollbar padding-right-50 pl-1">
        <h4 className="p-0">Manager Assistant will remind you to give light, bi-directional feedback.</h4>
        <FormFields />
      </div>
    </OnboardingWizardContentWrapper>
  );
}
